// PatternsForm.jsx
import { useState, useEffect } from "react"
import { UniversalDropDown } from "@fileops/swmm-react"
import { Grid, Button } from '@mui/material'
import "../../css/DemoCode.css"

/**
 * Options Dynamic Wave Form is a group of data inputs usually shown when clicking on Options->Dynamic Wave. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {string} target The name of the object targetted by this form.
 * @param {function} setFullModel Sets the full model in case of any updates.
 * @returns UI for interactive swmm modeling.
 */
export default function PatternsForm({model, setModel, target, setFullModel}) {
  const [monthNames ]   = useState(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'])
  const [dayNames]      = useState(['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'])
  const [hourNames]     = useState(['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM'])
  const [weekendNames]  = useState(['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM'])
  const [patternsTypes] = useState(['MONTHLY', 'DAILY', 'HOURLY', 'WEEKEND'])
  // This is all necessary in order to allow for saving and undoing.
  const [type, setType] = useState((model&&model.PATTERNS&&model.PATTERNS[target])?model.PATTERNS[target].Type:'MONTHLY')
  const [pattern, setPattern] = useState(monthNames)

  useEffect(()=>{
    setType((model&&model.PATTERNS&&model.PATTERNS[target])?model.PATTERNS[target].Type:'MONTHLY')
  }, [model])

  // When there is a change to an input element, modify the model.
  const updateValue = (val, position) => {
    // Don't let any undefined updates go through.
    if(val === undefined) val = ''
    if(model && model.PATTERNS){
      let updatedPattern = [...model.PATTERNS[target].Factors]
      updatedPattern[position] = val

      setModel(prev => ({
        ...prev,
        PATTERNS:{
          ...prev.PATTERNS,
          [target]: {
            Factors: updatedPattern,
            Type: type
          }
        }
      }))
    }
  }
  
  const updateType = (newType) => {
    switch (newType) {
      case 'MONTHLY': 
        setPattern(monthNames)
        break
      case 'DAILY': 
        setPattern(dayNames)
        break
      case 'HOURLY': 
        setPattern(hourNames)
        break
      case 'WEEKEND': 
        setPattern(weekendNames)
        break
      default:
        break
    }
    setModel(prev => ({
      ...prev,
      PATTERNS:{
        ...prev.PATTERNS,
        [target]: {
          ...prev.PATTERNS[target],
          Type: newType
        }
      }
    }))

    setType(newType)
  }
  
  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      PATTERNS: {
        ...prev.PATTERNS, 
        [target]: JSON.parse(JSON.stringify(model.PATTERNS[target]))
      }
    }))
  }

  return(
    <>
    {
      // This is all necessary in order to allow for saving and undoing.
      model &&
      model.PATTERNS &&
      <>
      <Button fullWidth onClick={saveEdits} style={{position:'sticky', top: '0', backgroundColor:'#000', borderRadius: '0'}}>Save Edits</Button>
      <label className='editor-small' >Type
        <UniversalDropDown style={{padding: '0'}}
          IDs={patternsTypes} 
          selectText={"Select a pattern type"} 
          value={model.PATTERNS[target].Type}
          onChange={(val)=>{updateType(val)}} >
        </UniversalDropDown>
      </label>
      </>
    }
    {
      // This is all necessary in order to allow for saving and undoing.
      model &&
      model.PATTERNS &&
      model.PATTERNS[target] &&
      <>
      <div style={{borderBottom:'3px solid #fff', paddingTop: '15px'}}>Mulitpliers</div>
        {
          pattern.map((v, i)=>(
            <Grid container key={"patternsform" + v}>
              <Grid item xs={6}>
                {
                    (<label style={{paddingTop: '1px', height: '21px'}} className='editor-small' key={'PatternsLabel'+v.toString()}>{v}</label>)
                }
              </Grid>
              <Grid item xs={6}>
                {
                    <input  type = "number"
                            style={{width: '95%', display: 'flex'}}
                            onChange={(e)=>{updateValue(e.target.value, i)}}
                            value={model.PATTERNS[target].Factors[i] >= 0?model.PATTERNS[target].Factors[i]:1}
                            id ={'Patterns'+v.toString()}
                            key={'Patterus'+v.toString()}
                    />
                }
              </Grid>
            </Grid>
          ))
        }
      </>
    }
    </>
  )
}